import { render, staticRenderFns } from "./third-case-study.vue?vue&type=template&id=a20da6bc&"
import script from "./third-case-study.vue?vue&type=script&lang=js&"
export * from "./third-case-study.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports